// extracted by mini-css-extract-plugin
module.exports = {"green-button":"NmmUpdatesTable_green-button__SjfLy"};